import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import {
  createRefill,
  createAroundUs,
  createQuestion,
  getBnbList,
  uploadFile,
  createCleaningItem,
  createTrashItem,
  createTrashDays,
  getAllTrashItem,
  updateTrashDays,
} from '../../helper/backend_helper';
import InfoTooltip from '../InfoTooltip';

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const UpdateTrashDays = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location?.state?.userData;
  console.log(userData);
  const [loading, setLoading] = useState(false);
  const [bnbValue, setbnbValue] = useState(userData.bnb || []);
  const [cityValue, setCityValue] = useState(userData.city || []);
  const [trashItem, settrashItem] = useState([]);
  const [values, setValues] = useState(
    userData.days.reduce((acc, dayData) => {
      acc[dayData.day] = { trashItem: dayData.trashItem.map((item) => item._id) };
      return acc;
    }, {})
  );

  console.log(values);
  const [bnbs, setBnB] = useState([]);
  const [trashItems, setTrashItems] = useState([]);

  async function fetchData() {
    try {
      const bnbRes = await getBnbList();
      setBnB(bnbRes?.data?.data);
      const itemsRes = await getAllTrashItem();
      setTrashItems(itemsRes?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  // Handle value changes
  const handleChange = (day, field, selectedValue) => {
    setValues((prevValues) => ({
      ...prevValues,
      [day]: {
        ...prevValues[day],
        [field]: selectedValue,
      },
    }));
  };
  const handleSave = async () => {
    try {
      setLoading(true);
      // Prepare the data in the required structure
      if (bnbValue.length === 0 && cityValue.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Select at least one BnB or city',
        });
        setLoading(false);
        return;
      }
      const data = {
        days: Object.entries(values).map(([day, data]) => ({
          day,
          trashItem: data.trashItem, // Array of ObjectIds
        })),
        bnb: bnbValue,
        city: cityValue,
      };
      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updateTrashDays(userData?._id, data, Categoryheaders);
      console.log(response);
      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Trash Days updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Update Trash Days </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Update Trash Days</Typography>
        </Stack>

        <FormControl sx={{ width: { xs: '100%', sm: 650 }, mb: 5 }}>
          <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="Properties this trash schedule applies to. Leave empty to target whole cities instead." /></FormLabel>
          <Select
            labelId="demo-multi-select-label"
            id="demo-multi-select"
            multiple
            value={bnbValue} // This will be an array
            onChange={(e) => setbnbValue(e.target.value)}
            renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
          >
            {bnbs?.map((user) => (
              <MenuItem key={user._id} value={user.BnBShortName}>
                <Checkbox checked={bnbValue.indexOf(user.BnBShortName) > -1} />
                {user.BnBShortName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ width: { xs: '100%', sm: 650 }, mb: 5 }}>
          <FormLabel sx={{ mb: 1 }}>Cities <InfoTooltip title="Apply this trash collection schedule to every BnB in the selected cities." /></FormLabel>
          <Select
            multiple
            value={cityValue}
            onChange={(e) => setCityValue(e.target.value)}
            renderValue={(selected) => selected.join(', ')}
          >
            {[...new Set(bnbs?.map((item) => item.city).filter(Boolean))].sort().map((city) => (
              <MenuItem key={city} value={city}>
                <Checkbox checked={cityValue.indexOf(city) > -1} />
                {city}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '50ch' },
          }}
          noValidate
          autoComplete="off"
        >
          {days.map((day) => (
            <Stack
              key={day}
              spacing={{ xs: 2, sm: 4 }}
              direction="row"
              alignItems="center"
              useFlexGap
              flexWrap="wrap"
              sx={{ mb: 3 }}
            >
              <h1 style={{ color: 'black', fontSize: '20px', fontWeight: 'bold', width: '200px' }}>{day}:</h1>

              {/* Trash Items Select */}
              <FormControl sx={{ width: 450 }}>
                <Select
                  multiple
                  value={values[day].trashItem}
                  onChange={(e) => handleChange(day, 'trashItem', e.target.value)}
                  renderValue={(selected) =>
                    trashItems
                      .filter((item) => selected.includes(item._id))
                      .map((item) => item.name)
                      .join(', ')
                  }
                >
                  {trashItems?.map((item) => (
                    <MenuItem key={item._id} value={item._id}>
                      <Checkbox checked={values[day].trashItem.includes(item._id)} />
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          ))}
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default UpdateTrashDays;
